import parse from 'html-react-parser'
import './Author.scss'

function Author({ author }) {
  const image = author?.authorImage

  return (
    author && (
      <div className='author d-flex gap-4'>
        <span className='author-image'>
          {image ? (
            <img
              src={image}
              alt={author?.name}
              className='mt-2'
              loading='lazy'
            />
          ) : (
            <i className='bi bi-person'></i>
          )}
        </span>
        <div className='author-info'>
          <h3 className='author-name'>{parse(author?.name || '')}</h3>
          {parse(author?.bio ?? '')}
        </div>
      </div>
    )
  )
}

export default Author
